export default {
  MEW_PRODUCTS: 'MEWProducts',
  LOGO: 'Logo',
  WHAT_IS_MEW: 'WhatIsMEW',
  WALLET_ACTIONS: 'WalletActions',
  BUY_ETH: 'BuyETH',
  BUY_ETH_MOBILE: 'BuyETHMobile'
};
